import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import EmbeddedSalesforceChatForOnboarding from './EmbeddedSalesforceChatForOnboarding';

const PlannerChatPicker = ({
  clientResource,
  ...rest
}) => {
  return pickFunction(clientResource, {
    [fr.relationships.onboardingChat.name]: () => (
      <EmbeddedSalesforceChatForOnboarding
        clientResource={clientResource}
        {...rest}
      />
    ),
    [fr.relationships.default.name]: () => null,
  });
};

export default PlannerChatPicker;
